import { useEffect, useState } from 'react';

import { useTranslation } from '@/hooks/useTranslation';
import { DataModelAttribute } from '@/types/DataModel';

const usePlaceholder = (attribute: DataModelAttribute, readonly: boolean = false) => {

    const [placeholder, setPlaceholder] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        // Don't show placeholder when readonly
        if (readonly) {
            setPlaceholder('');
            return;
        }

        const placeholderTranslationKey = `attribute.${attribute.name}.placeholder`;
        const placeholder = t(placeholderTranslationKey);

        // Only show a placeholder, if it's actually translated (instead of showing the key)
        if (placeholder !== placeholderTranslationKey) {
            setPlaceholder(placeholder);
        }

        // a placeholder is guaranteed to not change, so we only run this hook once
        //eslint-disable-next-line
    }, [readonly]);

    return placeholder;
};

export { usePlaceholder };
